import { config } from "../config/config";
import { getAuthToken } from "./tokenService.service";

export const performanceCheckpointService = {
  getPerformanceDSCheckpoints: async (branch_id: string, endDate: string) => {
    {
      const token = getAuthToken();

      const response = await fetch(
        `${config.baseURL}/performancecheckpoint/delivery-status`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ branch_id, end_date: endDate }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch delivery service checkpoints");
      }

      const json = await response.json();
      return json.data;
    }
  },

  getPerformanceTimestampCheckpoints: async (
    branch_id: string,
    endDate: string
  ) => {
    const token = getAuthToken();

    const response = await fetch(
      `${config.baseURL}/performancecheckpoint/timestamp`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ branch_id, end_date: endDate }),
      }
    );

    if (!response.ok) {
      throw new Error("Failed to fetch timestamp checkpoints");
    }

    const json = await response.json();
    return json.data;
  },

  getTimestampNasional: async (branch_id: string, endDate: string) => {
    const token = getAuthToken();

    const response = await fetch(
      `${config.baseURL}/performancecheckpoint/timestamp-nasional`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ branch_id, end_date: endDate }),
      }
    );

    if (!response.ok) {
      throw new Error("Failed to fetch pickup checkpoints");
    }

    const json = await response.json();
    return json.data;
  },
};
